import { Component } from '@angular/core';

@Component({
    selector: 'ols-checkout',
    template: '<router-outlet></router-outlet>',
})
export class CheckoutComponent {}
